import axios, { AxiosResponse } from "axios";
import { NamedResourceResponse, ResourceUsageLogResponse } from "../../models/SubscriptionNamedResources";
import { GetPageRequest } from "../../models/PageRequest";

export const getResourceUsage =
	(productId: string, subscriptionId: string, resourceId: string, getPageRequest: GetPageRequest) =>
	async (): Promise<AxiosResponse<ResourceUsageLogResponse[]>> => {
		return await axios.post(
			`/api/v1/${productId}/subscriptions/${subscriptionId}/NamedResources/${resourceId}/usage`,
			getPageRequest,
		);
	};

export const getActiveResourceListPage =
	(productId: string, subscriptionId: string, getPageRequest: GetPageRequest) =>
	async (): Promise<AxiosResponse<NamedResourceResponse[]>> => {
		return await axios.post(
			`/api/v1/${productId}/subscriptions/${subscriptionId}/NamedResources/active`,
			getPageRequest,
		);
	};

export const getInactiveResourceListPage =
	(productId: string, subscriptionId: string, getPageRequest: GetPageRequest) =>
	async (): Promise<AxiosResponse<NamedResourceResponse[]>> => {
		return await axios.post(
			`/api/v1/${productId}/subscriptions/${subscriptionId}/NamedResources/inactive`,
			getPageRequest,
		);
	};
